import { render } from "./SajuSipsung.vue?vue&type=template&id=666aaffc&scoped=true"
import script from "./SajuSipsung.vue?vue&type=script&lang=js"
export * from "./SajuSipsung.vue?vue&type=script&lang=js"

import "./SajuSipsung.vue?vue&type=style&index=0&id=666aaffc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666aaffc"]])

export default __exports__